import Api from '../../../../../../shared/Api';

export function transformFormDataToProductList(data: FormData): string[] {
    let productIds: string[] = [];

    data.forEach((value, key) => {
        let [_, productId] = key.split('-');
        if (value === 'on') {
            productIds.push(productId);
        }
    });

    return productIds;
}

export class OrderListApi {
    static splitOrder(data: FormData): Promise<any> {
        let orderId = data.get('orderId');

        let productIds = transformFormDataToProductList(data);

        if (!orderId) {
            return Promise.reject('No orderId provided when splitting order.');
        }

        return new Api().post(`/views/orders-list/unbooked/split/${orderId}`, {
            products: productIds
        });
    }

    static hideOrders(orderIds: number[]): Promise<any> {
        return new Api().post(`/views/orders-list/unbooked/hide`, {
            orderIds
        });
    }

    static unHideOrders(orderIds: number[]): Promise<any> {
        return new Api().post(`/views/orders-list/unbooked/unhide`, {
            orderIds
        });
    }
}
